// extracted by mini-css-extract-plugin
export default {"box-size":"parentPageBoxSizing_box-size__Boacd","box-size-wrapper":"parentPageBoxSizing_box-size-wrapper__VW2Le"};